import React from 'react'
import Img from 'gatsby-image'
import SocialIcon from './svgs/social-icon'

import styles from './hero.module.css'

export default ({ data }) => (
  <div className={styles.hero}>
    <Img
      className={styles.heroImage}
      alt={data.name}
      fluid={data.heroImage.fluid}
    />
    <div className={styles.heroDetails}>
      <h3 className={styles.heroHeadline}>{data.name}</h3>
      <p className={styles.heroTitle}>{data.title}</p>
      <p>{data.shortBio.shortBio}</p>
      <div className={styles.heroSocialIcons}>
        <SocialIcon name="twitter" url="https://twitter.com/skythediver" />
        <SocialIcon name="github" url="https://github.com/skylerwshaw" />
        <SocialIcon
          name="linkedin"
          url="https://www.linkedin.com/in/skylershaw/"
        />
      </div>
    </div>
  </div>
)
